export const employeeMockData = [
  {
    id: "emp-001",
    employee_code: "A001",
    name: "tranghmaid4",
    email: "tranghmaid4@gmail.com",
    phone: "0912-345-001",
    department: null,
    position: null,
    role_level: "admin",
    status: "active",
    created_at: "2026-06-23T08:00:00Z",
  },
  {
    id: "emp-002",
    employee_code: "A002",
    name: "Roxane",
    email: "roxanedeshawn925@gmail.com",
    phone: "0912-345-002",
    department: null,
    position: null,
    role_level: "trial",
    status: "active",
    created_at: "2026-06-23T08:00:00Z",
  },
  {
    id: "emp-003",
    employee_code: "A003",
    name: "羅曼莎",
    email: "lisanow481@gmail.com",
    phone: "0912-345-003",
    department: null,
    position: null,
    role_level: "trial",
    status: "active",
    created_at: "2026-06-27T08:00:00Z",
  },
];

export const departmentOptions = ["經營層", "客服部", "銷售部", "財務部", "物流部", "資訊部"];


export const roleLevelOptions = [
  { value: "admin", label: "超級管理員" },
  { value: "manager", label: "主管" },
  { value: "employee", label: "一般職員" },
  { value: "trial", label: "試用期" },
];

export const roleLevelBadge: Record<string, { bg: string; text: string; label: string }> = {
  admin: { bg: "bg-primary-100", text: "text-primary-700", label: "超級管理員" },
  manager: { bg: "bg-secondary-100", text: "text-secondary-700", label: "主管" },
  employee: { bg: "bg-background-100", text: "text-foreground-700", label: "一般職員" },
  trial: { bg: "bg-accent-100", text: "text-accent-700", label: "試用期" },
};